(() => {
 const root = document.querySelector('[data-rb-policy]');
 const body = root?.querySelector('.shopify-policy__body');
 if (!body || root.querySelector('.rb-policy-contents')) return;
 const title = root.querySelector('.shopify-policy__title h1')?.textContent.trim().toLocaleLowerCase();
 body.querySelectorAll('h1').forEach(old => {
  const heading = document.createElement('h2');
  for (const attribute of old.attributes) heading.setAttribute(attribute.name, attribute.value);
  while (old.firstChild) heading.append(old.firstChild);
  if (heading.textContent.trim().toLocaleLowerCase() === title) heading.classList.add('rb-policy-duplicate-title');
  old.replaceWith(heading);
 });
 body.querySelectorAll('p').forEach(paragraph => {
  const first = paragraph.firstElementChild;
  if (first?.tagName !== 'STRONG' || first.previousSibling?.textContent.trim() || first.nextSibling?.nodeName !== 'BR') return;
  const heading = document.createElement('h2');
  const lineBreak = first.nextSibling;
  heading.append(first);
  paragraph.before(heading);
  lineBreak.remove();
 });
 const headings = [...body.querySelectorAll('h2,h3')].filter(h => !h.classList.contains('rb-policy-duplicate-title') && h.textContent.trim());
 if (headings.length < 2) return;
 const toc = document.createElement('details'); toc.className = 'rb-policy-contents';
 const summary = document.createElement('summary'); summary.textContent = root.dataset.tocLabel;
 const list = document.createElement('ol');
 headings.forEach((heading,index) => {
  if (!heading.id) heading.id = 'rb-policy-section-' + (index + 1);
  const item = document.createElement('li'); const link = document.createElement('a');
  link.href = '#' + heading.id; link.textContent = heading.textContent.trim();
  item.append(link); list.append(item);
 });
 toc.append(summary,list); body.before(toc);
})();
